export default __webpack_public_path__ + "static/media/Teamwork-Black.7e110835.svg";